import React, { useState, useEffect } from 'react';
import { getRestaurantProfile, updateRestaurantProfile } from '../../services/api';
import { useNavigate } from 'react-router-dom';

function EditRestaurantProfileScreen() {
  const [restaurant, setRestaurant] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();
  const restaurantId = localStorage.getItem('restaurantId');

  useEffect(() => {
    if (!restaurantId) {
      setError('ID do restaurante não encontrado. Faça login novamente.');
      setLoading(false);
      return;
    }
    fetchRestaurantProfile();
  }, [restaurantId]);

  const fetchRestaurantProfile = async () => {
    setLoading(true);
    setError('');
    try {
      const data = await getRestaurantProfile();
      setRestaurant(data);
    } catch (err) {
      console.error('Failed to fetch restaurant profile:', err);
      setError('Não foi possível carregar o perfil do restaurante.');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRestaurant({ ...restaurant, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (!restaurantId) {
      setError('ID do restaurante não encontrado. Faça login novamente.');
      return;
    }

    try {
      await updateRestaurantProfile(restaurant);
      setSuccess('Perfil atualizado com sucesso!');
    } catch (err) {
      console.error('Failed to update restaurant profile:', err);
      setError('Falha ao atualizar perfil. Verifique os dados.');
    }
  };

  if (loading) {
    return <div style={styles.loading}>Carregando perfil do restaurante...</div>;
  }

  if (error && !restaurant) {
    return <div style={styles.error}>{error}</div>;
  }

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Editar Perfil do Restaurante</h2>
      <button onClick={() => navigate('/restaurant/dashboard')} style={styles.backButton}>
        Voltar ao Painel
      </button>

      {restaurant && (
        <div style={styles.formSection}>
          {error && <p style={styles.error}>{error}</p>}
          {success && <p style={styles.success}>{success}</p>}
          <form onSubmit={handleSubmit} style={styles.form}>
            <label style={styles.label}>Nome Comercial:</label>
            <input
              type="text"
              name="NomeComercial"
              value={restaurant.NomeComercial || ''}
              onChange={handleChange}
              style={styles.input}
              required
            />
            <label style={styles.label}>Razão Social:</label>
            <input
              type="text"
              name="RazaoSocial"
              value={restaurant.RazaoSocial || ''}
              onChange={handleChange}
              style={styles.input}
            />
            <label style={styles.label}>CNPJ:</label>
            <input
              type="text"
              name="CNPJ"
              value={restaurant.CNPJ || ''}
              onChange={handleChange}
              style={styles.input}
            />
            <label style={styles.label}>Telefone:</label>
            <input
              type="text"
              name="Telefone"
              value={restaurant.Telefone || ''}
              onChange={handleChange}
              style={styles.input}
            />
            <label style={styles.label}>Email:</label>
            <input
              type="email"
              name="Email"
              value={restaurant.Email || ''}
              onChange={handleChange}
              style={styles.input}
            />
            {/* Adicione mais campos conforme necessário */}
            <button type="submit" style={styles.submitButton}>
              Salvar Alterações
            </button>
          </form>
        </div>
      )}
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    backgroundColor: '#f0f2f5',
    minHeight: '100vh',
    fontFamily: 'Arial, sans-serif',
  },
  title: {
    color: '#333',
    marginBottom: '20px',
  },
  backButton: {
    backgroundColor: '#6c757d',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    padding: '10px 15px',
    cursor: 'pointer',
    marginBottom: '20px',
  },
  formSection: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    padding: '20px',
    marginBottom: '20px',
    width: '100%',
    maxWidth: '600px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    marginBottom: '5px',
    fontWeight: 'bold',
    color: '#555',
  },
  input: {
    padding: '10px',
    marginBottom: '15px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '16px',
  },
  submitButton: {
    backgroundColor: '#28a745',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    padding: '10px 15px',
    cursor: 'pointer',
    marginTop: '10px',
  },
  loading: {
    fontSize: '18px',
    color: '#555',
    marginTop: '50px',
  },
  error: {
    color: 'red',
    marginBottom: '10px',
    textAlign: 'center',
  },
  success: {
    color: 'green',
    marginBottom: '10px',
    textAlign: 'center',
  },
};

export default EditRestaurantProfileScreen;
